import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-annual-budget',
  templateUrl: './annual-budget.component.html',
  styleUrl: './annual-budget.component.scss',
  standalone: false,
})
export class AnnualBudgetComponent implements OnInit, OnChanges {
  @Input() annualBudget!: number;
  @Input() impactPerTraveller?: number;
  ratio: number = 0;
  calculateRatio() {
    this.ratio = this.annualBudget / 100;
  }

  ngOnInit() {
    this.calculateRatio();
  }
  ngOnChanges() {
    this.calculateRatio();
  }
}
